import type { MfgRecipeKind } from "@/lib/manufacturing/types";

const SHELF_KINDS = new Set<MfgRecipeKind>(["product", "option", "package"]);

export function recipeKindHasShelfPrice(kind: MfgRecipeKind): boolean {
  return SHELF_KINDS.has(kind);
}

export function formatShelfPriceInput(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return "";
  return String(value);
}

/** Blank clears the shelf price. A blank is not zero. */
export function parseShelfPriceInput(
  raw: string,
  label: string,
): { ok: true; value: number | null } | { ok: false; error: string } {
  const trimmed = raw.trim();
  if (!trimmed) return { ok: true, value: null };
  const n = Number(trimmed.replace(/[$,]/g, ""));
  if (!Number.isFinite(n) || n < 0) {
    return { ok: false, error: `${label} must be a dollar amount or blank.` };
  }
  return { ok: true, value: Math.round(n * 100) / 100 };
}
